export const GET_FACILITIES_DATA = "GET_FACILITIES_DATA";
